export default "__VITE_ASSET__DpZ8P3KA__"